import moment, { Moment } from 'moment';
import ChatGroup from '@/chat/models/ChatGroup';
import AssignmentData from '@/shared/models/AssignmentData';
import { OutletId } from '@/shared/models/Outlet';
import User, { UserId } from '@/shared/models/User';
import AbstractTask from './AbstractTask';
import MemoTag from './MemoTag';

export interface MemoId {__memoId: number}

type Assignee = User | ChatGroup;

export interface MemoData {
  description: string;
  deadline: Moment | null;
  resolvableBy: AssignmentData;
  tag: MemoTag | null;
}

export default class Memo extends AbstractTask {
  id!: MemoId;
  outletId!: OutletId;
  assignedUserId: UserId | null = null;
  resolvedOn: Moment | null = null;
  tag: MemoTag | null = null;
  isInvoiced = false;
  isResolvable = false;
  resolvedBy: User | null = null;
  resolvableBy: Assignee | null = null;
  createdBy: User | null = null;
  deadline: Moment | null = null;

  clone(): Memo {
    return Object.assign(new Memo(), this);
  }

  isResolved(): boolean {
    return this.resolvedOn !== null && this.resolvedBy !== null;
  }

  isResolvableByGroup(): boolean {
    return this.resolvableBy instanceof ChatGroup;
  }

  getAssignmentData(): AssignmentData {
    if (this.resolvableBy instanceof User) return { userId: this.resolvableBy?.id };
    if (this.resolvableBy instanceof ChatGroup) return { groupId: this.resolvableBy?.id };
    return null;
  }

  resolve(by: User): void {
    this.resolvedBy = by;
    this.resolvedOn = moment();
    this.isResolvable = false;
  }

  update(data: MemoData): void {
    this.tag = data.tag;
    this.description = data.description;
    this.deadline = data.deadline;

    if (!data.resolvableBy) {
      this.resolvableBy = null;
    } else if ('groupId' in data.resolvableBy) {
      this.resolvableBy = ChatGroup.withId(data.resolvableBy.groupId);
    } else if ('userId' in data.resolvableBy) {
      this.resolvableBy = User.withId(data.resolvableBy.userId);
    }
  }
}
